import { render } from "./serve-form.vue?vue&type=template&id=d7c8031e&scoped=true"
import script from "./serve-form.vue?vue&type=script&lang=js"
export * from "./serve-form.vue?vue&type=script&lang=js"

import "./serve-form.vue?vue&type=style&index=0&id=d7c8031e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c8031e"]])

export default __exports__